import { isFieldTypeSupported } from '@atlassian/ui-modifications-core/controllers';
import { GIC_VIEW_TYPE } from '../../../../common/constants/index.tsx';
import type { FieldConfig } from './types.tsx';

export const getSupportedFieldsCount = (fields: Record<string, FieldConfig>): number => {
	if (!fields) {
		return 0;
	}

	return Object.values<FieldConfig>(fields).filter(({ fieldType }: FieldConfig) =>
		isFieldTypeSupported(GIC_VIEW_TYPE, fieldType),
	).length;
};
